import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteService from './SiteService';
import TariffService from './TariffService';
import {
  IconButton, Menu, MenuItem,
  Table, TableHead, TableBody, TableRow, TableCell,
  Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Paper
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function MainMeterList() {
  const [mainMeters, setMainMeters] = useState([]);
  const [tariffMap, setTariffMap] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuMeterId, setMenuMeterId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    SiteService.getMainMetersBySite().then(res => setMainMeters(res.data));
    TariffService.getTariffs().then(res => {
      const m = res.data.reduce((acc, t) => { acc[t.tariffId] = t.name; return acc; }, {});
      setTariffMap(m);
    });
  }, []);

  const openMenu = (event, id) => {
    console.log('id in openMenu', id);
    setAnchorEl(event.currentTarget);
    setMenuMeterId(id);
  };
  const closeMenu = () => {
    setAnchorEl(null);
    //    setMenuMeterId(null);
  };
  const openDialog = () => {
    setDialogOpen(true);
    closeMenu();
  };
  const closeDialog = () => {
    setDialogOpen(false);
    setMenuMeterId(null);
  };
  const confirmDelete = () => {
    console.log('menuMeterId in confirmDelete', menuMeterId);
    SiteService.deleteMainMeter(menuMeterId)
      .then(() => {
        setMainMeters(prev => prev.filter(m => m.mainMeterId !== menuMeterId));
        toast.success('Ana sayaç başarıyla silindi!');
      })
      .catch(() => toast.error('Silme işlemi başarısız!'));
    closeDialog();
  };

  const getTariff = id => tariffMap[id] || '—';

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Ana Sayaçlar
      </Typography>

      <Button
        variant="contained"
        component={Link}
        to="/add-main-meter"
        color="secondary"
        sx={{ mb: 2 }}
      >
        Ana Sayaç Ekle
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Ana Sayaç</TableCell>
            <TableCell>Tarife</TableCell>
            <TableCell align="right">İşlemler</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mainMeters.map(m => (
            <TableRow key={m.mainMeterId} hover>
              <TableCell>{m.name}</TableCell>
              <TableCell>{getTariff(m.tariff.tariffId)}</TableCell>
              <TableCell align="right">
                <IconButton onClick={e => openMenu(e, m.mainMeterId)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        <MenuItem component={Link}
          to={menuMeterId ? `/update-main-meter/${menuMeterId}` : '#'}
          onClick={closeMenu}>
          Güncelle
        </MenuItem>
        <MenuItem component={Link}
          to={menuMeterId ? `/sub-meters/${menuMeterId}` : '#'}
          onClick={closeMenu}>
          Süzme Sayaçlar
        </MenuItem>
        <MenuItem onClick={openDialog}>Sil</MenuItem>
      </Menu>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>Silme Onayı</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bu ana sayacı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>İptal</Button>
          <Button color="error" variant="contained" onClick={confirmDelete}>
            Sil
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer position="top-right" autoClose={2000} />
    </Paper>
  );
}
